import { API_SYNC_DELAY_MS } from '@/config/constants';

export const PAST_EXPORTS_REFETCH_DELAY_MS = API_SYNC_DELAY_MS;
